import React, { useEffect, useState } from "react";

const fallbackColors = ["#f0b90b", "#26a17b", "#627eea", "#f7931a", "#6b7280", "#ec4899", "#14b8a6", "#8b9fb5"];

function CoinIcon({ symbol, logo, name, className = "", size = "normal" }) {
  const normalizedSymbol = String(symbol ?? "").trim().toUpperCase();
  const iconUrls = [...new Set([
    logo,
    normalizedSymbol ? `https://assets.coincap.io/assets/icons/${encodeURIComponent(normalizedSymbol.toLowerCase())}@2x.png` : "",
  ].filter(Boolean))];
  const [iconIndex, setIconIndex] = useState(0);
  const colorIndex = [...normalizedSymbol].reduce((total, character) => total + character.codePointAt(0), 0) % fallbackColors.length;
  const iconClassName = `${className} coin-icon coin-icon-${size}`.trim();

  useEffect(() => setIconIndex(0), [logo, normalizedSymbol]);

  if (iconUrls[iconIndex]) {
    return <img className={iconClassName} src={iconUrls[iconIndex]} alt={name ? `${name} icon` : ""} onError={() => setIconIndex((current) => current + 1)} />;
  }

  return <span className={`${iconClassName} coin-icon-fallback`} aria-hidden="true" style={{ "--coin-icon-color": fallbackColors[colorIndex] }}>{normalizedSymbol.slice(0, 1) || "?"}</span>;
}

export default CoinIcon;